import React, { Component } from "react";
import ApiEndpoints from "../../../constants/api_endpoints";
import store from "../../../store";
import { setLoader } from "../../../actions/action-creators";
import moment from "moment";

const fmtINR   = (v) => v != null ? "₹" + Number(v).toLocaleString("en-IN", { minimumFractionDigits: 2 }) : "₹0.00";
const fmtDT    = (v) => { const m = moment(v); return (v && m.isValid()) ? m.utcOffset("+05:30").format("Do MMM YYYY, hh:mm A") : "—"; };
const fmtRefId = (id) => id ? "DH" + String(id).padStart(3, "0") : "—";

// status integer → { label, bg, color }
const HISTORY_STATUS = {
    0: { label: "INITIATED", bg: "#fff7e6", color: "#d46b08" },
    1: { label: "CONFIRMED", bg: "#e6f7ee", color: "#1a7a42" },
    2: { label: "REJECTED",  bg: "#fff0f0", color: "#c0392b" },
};

const historyStatusBadge = (status) => {
    const cfg = HISTORY_STATUS[status] || { label: String(status), bg: "#f0f0f0", color: "#666" };
    return (
        <span style={{ background: cfg.bg, color: cfg.color, borderRadius: 999, padding: "3px 10px", fontSize: 11, fontWeight: 700, whiteSpace: "nowrap" }}>
            {cfg.label}
        </span>
    );
};

const BrandLogo = ({ src, name }) => {
    const [err, setErr] = React.useState(false);
    if (!src || err) {
        return (
            <div style={{ width: 28, height: 28, borderRadius: 8, background: "#f0f0f0", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, flexShrink: 0 }}>
                {(name || "?").charAt(0).toUpperCase()}
            </div>
        );
    }
    return <img src={src} alt={name} style={{ width: 28, height: 28, borderRadius: 8, objectFit: "contain", background: "#f8f8f8", flexShrink: 0 }} onError={() => setErr(true)} />;
};

const HISTORY_STATUS_FILTERS = [
    { key: null,  label: "All"       },
    { key: 0,     label: "Initiated" },
    { key: 1,     label: "Confirmed" },
    { key: 2,     label: "Rejected"  },
];

class UserDeals extends Component {
    constructor(props) {
        super(props);
        this.state = {
            subTab:        "best",
            dealsList:     [],
            summary:       {},
            history:       [],
            historyFilter: 0,       // filter key: null=all, 0=initiated, 1=confirmed, 2=rejected
        };
    }

    componentDidMount() {
        this.fetchAll();
    }

    fetchAll = async () => {
        store.dispatch(setLoader(true));
        const uid = this.props.user_id;
        const [dealsRes, summaryRes, historyRes] = await Promise.allSettled([
            ApiEndpoints.Deals.fetchAll(),
            ApiEndpoints.Deals.fetchUserSummary({ user_id: uid }),
            ApiEndpoints.Deals.fetchUserHistory({ user_id: uid }),
        ]);
        this.setState({
            dealsList: dealsRes.status   === "fulfilled" ? dealsRes.value.data.data   || [] : [],
            summary:   summaryRes.status === "fulfilled" ? summaryRes.value.data.data || {} : {},
            history:   historyRes.status === "fulfilled" ? historyRes.value.data.data || [] : [],
        });
        store.dispatch(setLoader(false));
    };

    renderSummary() {
        const { summary, history } = this.state;
        const totalUsed    = (Number(summary.PENDING) || 0) + (Number(summary.VERIFIED) || 0) + (Number(summary.REJECTED) || 0);
        const totalActvd   = Number(summary.VERIFIED) || 0;
        const cashback     = Number(summary.PAYOUT) || 0;
        return (
            <div style={S.summaryCard}>
                <div style={S.summaryLabel}>DEALS &amp; CASHBACK SUMMARY</div>
                <div style={S.summaryKpis}>
                    <div>
                        <div style={S.kpiLabel}>Total Cashback Earned</div>
                        <div style={{ ...S.kpiValue, color: "#888" }}>{fmtINR(cashback)}</div>
                    </div>
                    <div>
                        <div style={S.kpiLabel}>Deals Used</div>
                        <div style={{ ...S.kpiValue, color: "#1a1a1a" }}>{totalUsed}</div>
                    </div>
                    <div>
                        <div style={S.kpiLabel}>Deals Activated</div>
                        <div style={{ ...S.kpiValue, color: "#888" }}>{totalActvd}</div>
                    </div>
                </div>
            </div>
        );
    }

    renderBestDeals() {
        const { dealsList, history } = this.state;
        // build a map job_id → user interaction
        const usedMap = {};
        history.forEach(h => {
            if (!usedMap[h.job_id]) usedMap[h.job_id] = [];
            usedMap[h.job_id].push(h);
        });

        return (
            <div>
                {this.renderSummary()}
                <div style={S.sectionTitle}>All Listed Deals</div>
                {dealsList.length === 0 ? (
                    <div style={S.empty}>No deals found.</div>
                ) : (
                    <div style={S.tableWrapper}>
                        <table style={S.table}>
                            <thead>
                                <tr style={S.tHead}>
                                    <th style={S.th}>Brand</th>
                                    <th style={S.th}>Category</th>
                                    <th style={S.th}>Cashback %</th>
                                    <th style={S.th}>Description</th>
                                    <th style={S.th}>Status</th>
                                    <th style={S.th}>Used</th>
                                    <th style={S.th}>Activated</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dealsList.map((deal, i) => {
                                    const emp        = deal.Employer || {};
                                    const brandName  = emp.employer_name || deal.title || "—";
                                    const logoUrl    = emp.logo_key || null;
                                    const category   = deal.tags || deal.job_category || "—";
                                    const cashback   = deal.payout != null ? deal.payout + "%" : (deal.rewards ? deal.rewards : "—");
                                    const desc       = deal.tag_line || "Earn on every order";
                                    const isActive   = deal.archive_status === 0;
                                    const interactions = usedMap[deal.job_id] || [];
                                    const isUsed     = interactions.length > 0;
                                    const isActvd    = interactions.some(h => h.status === 1);
                                    return (
                                        <tr key={i} style={S.tRow}>
                                            <td style={S.td}>
                                                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                    <BrandLogo src={logoUrl} name={brandName} />
                                                    <span style={{ fontWeight: 700, color: "#1a1a1a" }}>{brandName}</span>
                                                </div>
                                            </td>
                                            <td style={{ ...S.td, color: "#555" }}>{category}</td>
                                            <td style={{ ...S.td, fontWeight: 700, color: "#1677ff" }}>{cashback}</td>
                                            <td style={{ ...S.td, color: "#666", fontSize: 12 }}>{desc}</td>
                                            <td style={S.td}>
                                                <span style={{
                                                    background: isActive ? "#e6f7ee" : "#f0f0f0",
                                                    color:      isActive ? "#1a7a42" : "#888",
                                                    borderRadius: 999, padding: "3px 10px",
                                                    fontSize: 11, fontWeight: 700, whiteSpace: "nowrap"
                                                }}>
                                                    {isActive ? "ACTIVE" : "INACTIVE"}
                                                </span>
                                            </td>
                                            <td style={S.td}>
                                                {isUsed
                                                    ? <span style={{ color: "#1a7a42", fontWeight: 700, fontSize: 13 }}>✓ Used</span>
                                                    : <span style={{ color: "#bbb", fontSize: 13 }}>Not Used</span>}
                                            </td>
                                            <td style={S.td}>
                                                {isActvd
                                                    ? <span style={{ color: "#1a7a42", fontWeight: 700, fontSize: 13 }}>✓ Activated</span>
                                                    : <span style={{ color: "#bbb", fontSize: 13 }}>—</span>}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }

    renderDealsHistory() {
        const { history, historyFilter } = this.state;

        // counts per status for filter pills
        const counts = { 0: 0, 1: 0, 2: 0 };
        history.forEach(h => { if (counts[h.status] != null) counts[h.status]++; });

        const filtered = historyFilter === null ? history : history.filter(h => h.status === historyFilter);

        return (
            <div>
                {/* Filter pills */}
                <div style={S.filterRow}>
                    {HISTORY_STATUS_FILTERS.map(f => {
                        const isActive = historyFilter === f.key;
                        const count    = f.key === null ? history.length : counts[f.key];
                        return (
                            <button
                                key={String(f.key)}
                                style={{ ...S.filterPill, ...(isActive ? S.filterPillActive : {}) }}
                                onClick={() => this.setState({ historyFilter: f.key })}
                            >
                                {f.label}
                                <span style={{ ...S.filterCount, background: isActive ? "rgba(255,255,255,0.25)" : "#f0f0f0", color: isActive ? "#fff" : "#555" }}>
                                    {count}
                                </span>
                            </button>
                        );
                    })}
                </div>

                {filtered.length === 0 ? (
                    <div style={S.empty}>No deals found for this filter.</div>
                ) : (
                    <div style={S.tableWrapper}>
                        <table style={S.table}>
                            <thead>
                                <tr style={S.tHead}>
                                    <th style={S.th}>Brand</th>
                                    <th style={S.th}>Status</th>
                                    <th style={S.th}>Cashback Earned</th>
                                    <th style={S.th}>Remark</th>
                                    <th style={S.th}>Created Date</th>
                                    <th style={S.th}>Updated Date</th>
                                    <th style={{ ...S.th, textAlign: "right" }}>Ref ID</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map((h, i) => {
                                    const jobData   = h.jobData || {};
                                    const brandName = jobData.deal_name || "—";
                                    const logoUrl   = jobData.deal_logo  || null;
                                    const cashback  = h.FormResponseMetadata?.payout || h.cashback_amount || null;
                                    return (
                                        <tr key={i} style={S.tRow}>
                                            <td style={S.td}>
                                                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                                    <BrandLogo src={logoUrl} name={brandName} />
                                                    <span style={{ fontWeight: 700, color: "#1a1a1a" }}>{brandName}</span>
                                                </div>
                                            </td>
                                            <td style={S.td}>{historyStatusBadge(h.status)}</td>
                                            <td style={{ ...S.td, fontWeight: 700, color: "#1a7a42" }}>
                                                {cashback != null ? fmtINR(cashback) : "—"}
                                            </td>
                                            <td style={{ ...S.td, color: "#666", fontSize: 12 }}>
                                                {h.remark || h.status_comment || "Waiting for cashback to be tracked"}
                                            </td>
                                            <td style={{ ...S.td, fontSize: 12, color: "#555", whiteSpace: "nowrap" }}>
                                                {fmtDT(h.created_on)}
                                            </td>
                                            <td style={{ ...S.td, fontSize: 12, color: "#555", whiteSpace: "nowrap" }}>
                                                {fmtDT(h.modified_on)}
                                            </td>
                                            <td style={{ ...S.td, textAlign: "right", fontSize: 12, color: "#aaa", fontFamily: "monospace" }}>
                                                {fmtRefId(h.form_response_id)}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        );
    }

    render() {
        const { subTab } = this.state;
        return (
            <div>
                {/* Sub-tabs */}
                <div style={S.subTabRow}>
                    {[{ key: "best", label: "🏷️ Best Deals" }, { key: "history", label: "📋 Deals History" }].map(t => (
                        <button
                            key={t.key}
                            style={{ ...S.subTab, ...(subTab === t.key ? S.subTabActive : {}) }}
                            onClick={() => this.setState({ subTab: t.key })}
                        >
                            {t.label}
                        </button>
                    ))}
                </div>

                {subTab === "best"    && this.renderBestDeals()}
                {subTab === "history" && this.renderDealsHistory()}
            </div>
        );
    }
}

const S = {
    subTabRow:   { display: "flex", gap: 0, marginBottom: 24, border: "1.5px solid #e0e0e0", borderRadius: 10, overflow: "hidden", width: "fit-content" },
    subTab:      { padding: "10px 24px", fontWeight: 600, fontSize: 13, border: "none", cursor: "pointer", background: "#fff", color: "#555", outline: "none" },
    subTabActive:{ background: "#1677ff", color: "#fff" },

    summaryCard:   { background: "#f0faf4", border: "1px solid #c3e6cb", borderRadius: 14, padding: "18px 22px", marginBottom: 24 },
    summaryLabel:  { fontSize: 11, fontWeight: 700, color: "#999", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 16 },
    summaryKpis:   { display: "flex", gap: 40, flexWrap: "wrap" },
    kpiLabel:      { fontSize: 12, color: "#888", marginBottom: 4 },
    kpiValue:      { fontSize: 22, fontWeight: 800, color: "#1a1a1a" },

    sectionTitle:  { fontSize: 15, fontWeight: 700, color: "#1a1a1a", marginBottom: 14 },

    filterRow:       { display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 18 },
    filterPill:      { display: "inline-flex", alignItems: "center", gap: 6, padding: "7px 14px", borderRadius: 999, border: "1.5px solid #e0e0e0", background: "#fff", fontSize: 13, fontWeight: 600, color: "#555", cursor: "pointer", outline: "none" },
    filterPillActive:{ background: "#1677ff", borderColor: "#1677ff", color: "#fff" },
    filterCount:     { borderRadius: 999, padding: "1px 7px", fontSize: 11, fontWeight: 700 },

    tableWrapper:  { border: "1px solid #e8e8e8", borderRadius: 10, overflowX: "auto" },
    table:         { width: "100%", borderCollapse: "collapse", fontSize: 13 },
    tHead:         { background: "#f5f5f5" },
    th:            { padding: "10px 14px", textAlign: "left", fontWeight: 600, color: "#555", borderBottom: "1px solid #e8e8e8", whiteSpace: "nowrap" },
    tRow:          { borderBottom: "1px solid #f0f0f0" },
    td:            { padding: "11px 14px", color: "#333", verticalAlign: "middle" },
    empty:         { padding: "40px 20px", textAlign: "center", color: "#aaa", fontSize: 14 },
};

export default UserDeals;
